/* @flow */

import ExpressionOfGratitudePostBraindate from 'src/shared/app/expression-of-gratitude/component/modal/ExpressionOfGratitudePostBraindate';
import NewTopicNotificationFirstLogin from 'src/shared/app/topic/new/component/NewTopicNotificationFirstLogin';
import NewTopicNotificationReturning from 'src/shared/app/topic/new/component/NewTopicNotificationReturning';
import NewTopicNotificationTopicEngagement from 'src/shared/app/topic/new/component/NewTopicNotificationTopicEngagement';
import BraindateFeedbackModal from 'src/shared/components/domain/braindate/modal/BraindateFeedbackModal';

export const NOTIFICATION_COMPONENT_KEYS = {
  NEW_TOPIC_FIRST_LOGIN: 'NEW_TOPIC_FIRST_LOGIN',
  TOPIC_ENGAGEMENT_ONGOING_EVENTS: 'TOPIC_ENGAGEMENT_ONGOING_EVENTS',
  NEW_TOPIC_RETURNING: 'NEW_TOPIC_RETURNING',
  BRAINDATE_FEEDBACK: 'BRAINDATE_FEEDBACK',
  EXPRESSION_RECEIVED: 'EXPRESSION_RECEIVED',
};

export const NOTIFICATION_COMPONENT_MAPPGIN = {
  [NOTIFICATION_COMPONENT_KEYS.NEW_TOPIC_FIRST_LOGIN]:
    NewTopicNotificationFirstLogin,
  [NOTIFICATION_COMPONENT_KEYS.TOPIC_ENGAGEMENT_ONGOING_EVENTS]:
    NewTopicNotificationTopicEngagement,
  [NOTIFICATION_COMPONENT_KEYS.NEW_TOPIC_RETURNING]:
    NewTopicNotificationReturning,
  [NOTIFICATION_COMPONENT_KEYS.BRAINDATE_FEEDBACK]: BraindateFeedbackModal,
  [NOTIFICATION_COMPONENT_KEYS.EXPRESSION_RECEIVED]:
    ExpressionOfGratitudePostBraindate,
};
